import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ddt from '@wix/da-ddt';
import { useIsCurrentUserDeviationAuthor } from '../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { expandAndFocusCommentPanel } from '../../../DeviationPage/redux/actions';
import CommentTooltip from './CommentTooltip';
import useCommentOnDownloadSuggest from './useCommentOnDownloadSuggest';
const logger = ddt.createLogger('downloadbutton');
/** Wraps the download button in handlers that, when a download starts, open
 *  a tooltip that suggests the user add a comment to the deviation too. */ const DownloadButtonWithCommentPrompt = ({ buttonComponent: ButtonComponent, deviation, className })=>{
    const isAuthor = useIsCurrentUserDeviationAuthor(deviation);
    const { commentTooltipVisible, showCommentSuggestionTooltip: showTooltip, hideCommentSuggestionTooltip: hideTooltip, pauseCommentSuggestionTooltip: pauseTooltip, resumeCommentSuggestionTooltip: resumeTooltip } = useCommentOnDownloadSuggest();
    // todo: consider moving useCommentOnDownloadSuggest into this component
    const dispatch = useDispatch();
    const handleTooltipDismiss = useCallback(()=>{
        logger.log('hiding tooltip and expanding comment box');
        hideTooltip();
        dispatch(expandAndFocusCommentPanel(deviation, 'primary'));
    }, [
        hideTooltip,
        dispatch,
        deviation
    ]);
    const downloadButton = /*#__PURE__*/ React.createElement(ButtonComponent, {
        deviation: deviation,
        onDownload: showTooltip,
        onMouseEnter: pauseTooltip,
        onMouseLeave: resumeTooltip
    });
    commentTooltipVisible && logger.log('comment tooltip should be visible');
    return !isAuthor && commentTooltipVisible ? /*#__PURE__*/ React.createElement(CommentTooltip, {
        className: className,
        onDismiss: handleTooltipDismiss
    }, downloadButton) : /*#__PURE__*/ React.createElement("span", {
        className: className
    }, downloadButton);
};
DownloadButtonWithCommentPrompt.displayName = 'DownloadButtonWithCommentPrompt';
export default DownloadButtonWithCommentPrompt;
